import SignUpVerification from "./signup-verification.container";

export default SignUpVerification